import { render, staticRenderFns } from "./GlobalSnackbar.vue?vue&type=template&id=0060414e&scoped=true"
import script from "./GlobalSnackbar.vue?vue&type=script&lang=js"
export * from "./GlobalSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0060414e",
  null
  
)

export default component.exports